module.exports = __webpack_public_path__ + "static/img/logo_22.d991ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_22.png
// module id = O/zx
// module chunks = 1